// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"804612a9","712":"0154c776"}[chunkId] + ".chunk.js";
};